module.exports = __webpack_public_path__ + "static/media/BE1AML.b01ed32b.jpg";